export default __webpack_public_path__ + "static/media/cow-two.edca48f6.jpeg";